// extracted by mini-css-extract-plugin
module.exports = {"headerWrapper":"_3pINo","headerCategoriesWrapper":"TO5En","headerCategories":"_1E__T","gridWide":"_25xlk"};